import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '../../components/templates/AppShell';
import { AuthInitializer } from '../../auth/AuthInitializer';
import { ProtectedRoute } from '../../auth/ProtectedRoute';
import { LoginPage } from '../../pages/LoginPage';
import { PlaceholderPage } from '../../pages/PlaceholderPage';
import { CategoriesPage, CustomersPage, SuppliersPage, UnitsOfMeasurePage, WarehousesPage } from '../../features/catalog/CatalogPages';
import { ProductsPage } from '../../features/catalog/ProductsPage';
import { PurchasesPage, GoodsReceiptsPage, InventoryPage, InventoryMovementsPage, InventoryAdjustmentsPage } from '../../features/transactions/Phase3Pages';
import { SalesPage } from '../../features/sales/SalesPage';
import { UsersPage, RolesPage, PermissionsPage } from '../../features/admin/AdminPages';

const modules: Array<[string, string]> = [
  ['/products', 'Products'],
  ['/categories', 'Categories'],
  ['/units-of-measure', 'Units of Measure'],
  ['/customers', 'Customers'],
  ['/suppliers', 'Suppliers'],
  ['/warehouses', 'Warehouses'],
  ['/purchases', 'Purchases'],
  ['/goods-receipts', 'Goods Receipts'],
  ['/inventory', 'Inventory'],
  ['/inventory-adjustments', 'Inventory Adjustments'],
  ['/sales', 'Sales'],
  ['/users', 'Users'],
  ['/roles', 'Roles'],
];

function ProtectedApp() {
  return (
    <AppShell>
      <Routes>
        <Route path="/products/*" element={<ProductsPage />} />
        <Route path="/categories/*" element={<CategoriesPage />} />
        <Route path="/units-of-measure/*" element={<UnitsOfMeasurePage />} />
        <Route path="/customers/*" element={<CustomersPage />} />
        <Route path="/suppliers/*" element={<SuppliersPage />} />
        <Route path="/warehouses/*" element={<WarehousesPage />} />
        <Route path="/purchases/*" element={<PurchasesPage />} />
        <Route path="/goods-receipts/*" element={<GoodsReceiptsPage />} />
        <Route path="/inventory/movements/*" element={<InventoryMovementsPage />} />
        <Route path="/inventory/*" element={<InventoryPage />} />
        <Route path="/inventory-adjustments/*" element={<InventoryAdjustmentsPage />} />
        <Route path="/sales/*" element={<SalesPage />} />
        <Route path="/users/*" element={<UsersPage />} />
        <Route path="/roles/*" element={<RolesPage />} />
        <Route path="/permissions/*" element={<PermissionsPage />} />
        {modules.filter(([path]) => !['/products', '/categories', '/units-of-measure', '/customers', '/suppliers', '/warehouses', '/purchases', '/goods-receipts', '/inventory', '/inventory-adjustments', '/sales', '/users', '/roles'].includes(path)).map(([path, title]) => (
          <Route key={path} path={`${path}/*`} element={<PlaceholderPage title={title} />} />
        ))}
        <Route path="/" element={<PlaceholderPage title="Welcome" description="Select a module from the navigation to get started." />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

export function AppRouter() {
  return (
    <AuthInitializer>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}><Route path="/*" element={<ProtectedApp />} /></Route>
      </Routes>
    </AuthInitializer>
  );
}
